import React, { Component } from 'react';

import classes from './InputAuth.css';


class Input extends Component {


    state = {
        checked: false
    }



    changeInputHandler = () => {
        
        this.setState({checked: !this.state.checked})

    }


    render() {

        let inputElement = null;

        const inputClasses = [classes.InnerElements];

        if (this.props.invalid && this.props.shouldValidate ) {
            inputClasses.push(classes.Invalid);
        }

        let passInput = 
            <input className={inputClasses.join(' ')}
                {...this.props.elementConfig} value={this.props.value}
                onChange={this.props.changed}/>

        if (this.state.checked) {
            passInput = 
                <input className={inputClasses.join(' ')}
                    type='text' placeholder='' value={this.props.value}
                    onChange={this.props.changed}/>
        }   

        
    
        switch (this.props.elementType) {
            case ('input'): 
                inputElement = 
                    <div className={classes.InputWrapper}>
                        <p>{this.props.name}</p>
                        <input className={inputClasses.join(' ')}
                        {...this.props.elementConfig} value={this.props.value}
                        onChange={this.props.changed}/>
                    </div>
                break
            case ('password'): 
                inputElement = 
                    <div className={classes.InputPassWrapper}>
                        <p>{this.props.name}</p>
                        <div className={classes.PasswordWrapper}>

                            {passInput}

                            <div className={classes.CheckBoxSection}>   
                                <label className={classes.CheckBox}>
                                    <input type="checkbox" className={classes.Box} onClick={this.changeInputHandler}/>
                                    <span className={classes.Checkmark}></span>
                                </label>
                                <p>show</p>
                            </div> 
                        </div>
                    </div>
                break
            case ('textarea'):
                inputElement = <textarea className={inputClasses}
                    {...this.props.elementConfig} value={this.props.value}
                    onChange={this.props.changed} />
                break
            case('timeAndDate'):
                inputElement = 
                    <div className={classes.DateWrapper}>
                        <p>Release Date: </p>
                        <input className={inputClasses}
                        {...this.props.elementConfig} value={this.props.value}
                        onChange={this.props.changed}/>
                    </div>
                break;
            default: 
                inputElement = <input className={inputClasses} 
                    {...this.props.elementConfig} value={this.props.value} />
        }



        let validationError = null;
        if (this.props.invalid && this.props.touched){
            validationError = <p className={classes.ValidationError}>
                {this.props.errorMessage}
            </p>
        }



        return (
            <div className={classes.InputElement} >
                <label className={classes.Label}>
                    {this.props.label}
                </label>
                {inputElement}
                {validationError}
            </div>
        )
    }
}

export default Input


// WEBPACK FOOTER //
// ./src/components/UI/InputAuth/InputAuth.js